import { app } from '../../../../../../app';
import { Controller } from './create-label.controller';

app.component('companyUserLabelNew', {
    bindings: {
        companyId: '<',
        labels: '='
    },
    controller: Controller,
    templateUrl: require('./create-label.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/create-label/create-label.component..js